/*
 * File: TodaysMeeting.tsx
 * Project: a-a
 * File Created: Sunday, 10th November 2024 12:26:38 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 6th November 2025 11:27:23 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
/*
 * File: Account.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 9:48:32 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Sunday, 10th November 2024 12:25:09 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect, useState } from 'react';
import InfiniteScrollColumn from '../../InfiniteScrollColumn/InfiniteScrollColumn';
import { Box, Typography } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';
import TodaysMeetingCard from './TodaysMeetingCard/TodaysMeetingCard';
import CustomButton from '../../CustomButton/CustomButton';
import { AuthService } from '../../../../service/auth.service';
import { Link, useLocation } from 'react-router-dom';
import msalInstance from '../../../../utilities/m365-login';
import axios from 'axios';
import { LightTooltip } from '../../CustomTooltip/CustomTooltip';
import styles from './TodaysMeeting.module.css';
type TodaysMeeting = {
  attendees: string[];
  body: string;
  end: string;
  location: string;
  meetingLink: string;
  organizer: string;
  start: string;
  subject: string;
};

const TodaysMeeting = () => {
  const location = useLocation();
  const screenHeight = window.innerHeight;
  const Email = sessionStorage.getItem('current-user') || '';
  const msToken = sessionStorage.getItem('MSToken') || '';
  const IsSlackConnecting = sessionStorage.getItem('slackConnecting') === 'true';
  const Meetings: null | TodaysMeeting[] = sessionStorage.getItem('meetings')
    ? (JSON.parse(sessionStorage.getItem('meetings') as string).meetings as TodaysMeeting[])
    : null;
  const [events, setEvents] = useState<null | TodaysMeeting[]>(Meetings);
  const [loading, setLoading] = useState(Meetings ? false : true);
  const [error, setError] = useState(null);

  const fetchToken = async (code: string = '', isExistingAccessTokenValid: boolean = false) => {
    try {
      setLoading(true);
      const res = await AuthService.ms_team_events(code, Email, isExistingAccessTokenValid);
      // console.log(res?.meetings);
      sessionStorage.setItem('MSToken', 'true');
      if (res) {
        sessionStorage.setItem('meetings', JSON.stringify(res));
        setEvents(res.meetings);
      }
    } catch (err: any) {
      console.log(err);
      setError(err);
      setEvents((prev) => prev);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    location?.search?.split('code=')[1] &&
      !IsSlackConnecting &&
      fetchToken(location?.search?.split('code=')[1]);
    if (msToken && msToken === 'true') {
      fetchToken('', true);
    }
  }, [location?.search?.split('code=')[1], msToken]);

  const Header = () => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant='responsiveHeading3'>
          Today's Meeting {Array.isArray(events) ? `(${events?.length})` : ''}
        </Typography>
        {
          // (Array.isArray(events) || Array.isArray(Meetings)) &&
          msToken && msToken === 'true' && (
            <LightTooltip
              title={
                <Typography variant='body3' color={zeplinColor.Neutral1}>
                  Refresh
                </Typography>
              }
              placement='bottom-end'
              style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
              // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
            >
              <Box
                sx={{
                  borderRadius: '50px',
                  width: { xs: '28px', xl: '48px' },
                  height: { xs: '28px', xl: '48px' },
                  border: `1px solid ${zeplinColor.Neutral6}`,
                  // p: '0px 10px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: zeplinColor.Neutral4,
                    // border: `1px solid ${zeplinColor.BasicBlack}`,
                  },
                }}
                onClick={() => fetchToken('', true)}
              >
                <img
                  src={'/assets/refresh.svg'}
                  alt='refresh-activity'
                  id='refresh-activity'
                  className={styles.icon}
                />
              </Box>
            </LightTooltip>
          )
        }
        {/* <Link
          to={
            'https://login.microsoftonline.com/dbbc81d8-5d27-4c7d-86be-a95f37ae7601/oauth2/v2.0/authorize?client_id=de5103b1-fa13-4bd4-bf80-3630c23c345c&response_type=code&redirect_uri=http://localhost:3000/dashboard&scope=https://graph.microsoft.com/.default'
          }
          // target='_blank'
          // rel='noopener noreferrer'
        >
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: '10px 10px 10px 16px',
              backgroundColor: zeplinColor.Neutral1,
              border: `1px solid ${zeplinColor.Neutral6}`,
              display: 'flex',
              gap: '8px',
              // flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Typography variant='body3'>Office365</Typography>
            <img src='/assets/link-2.svg' width={20} height={20} />
          </CustomCard>
        </Link> */}
        {/* <Box onClick={login}>
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: '10px 10px 10px 16px',
              backgroundColor: zeplinColor.Neutral1,
              border: `1px solid ${zeplinColor.Neutral6}`,
              display: 'flex',
              gap: '8px',
              // flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Typography variant='body3'>Office365</Typography>
            <img src='/assets/link-2.svg' width={20} height={20} />
          </CustomCard>
        </Box> */}
      </Box>
    );
  };
  // console.log(events, Array.isArray(events));
  const Column = () => {
    return (
      <>
        {!events || (Array.isArray(events) && !events?.length) ? (
          <Box
            className={styles['no-meeting-outer']}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center', // Add this to center vertically
              alignItems: 'center', // Add this to center horizontally
              zIndex: 100,
              position: 'relative',
              overflowY: 'auto', // Changed from 'scroll' to 'auto' to hide scrollbar when not needed
              height: { xs: 'calc(100vh - 630px)', xl: 'calc(100vh - 730px)' },
              // padding: '16px', // Add padding for better spacing
            }}
          >
            <Box
              className={styles['no-meeting']}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100,
                position: 'relative',
                textAlign: 'center', // Add this for text alignment
                maxWidth: '280px', // Add max width to constrain content
                // marginBottom: '24px', // Add margin to separate from button
              }}
            >
              <img
                src={'/assets/no-meeting.svg'}
                className={styles['no-meeting-icon']}
                alt='no-meetings-logo'
                // style={{ marginBottom: '16px' }} // Add margin below image
              />
              <Box
                className={styles['no-meeting-text']}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '100%', // Make sure text box takes full width
                }}
              >
                <Typography
                  variant='responsiveHeading3'
                  color={zeplinColor.BasicBlack}
                  sx={{ textAlign: 'center' }} // Ensure text is centered
                >
                  {(!Array.isArray(events) || !Array.isArray(Meetings)) &&
                  (!msToken || msToken !== 'true')
                    ? 'Get Started with Meetings'
                    : 'No Meetings Today'}
                </Typography>
              </Box>
            </Box>

            {(!msToken || msToken !== 'true') && (
              <Link
                to={`https://login.microsoftonline.com/dbbc81d8-5d27-4c7d-86be-a95f37ae7601/oauth2/v2.0/authorize?client_id=de5103b1-fa13-4bd4-bf80-3630c23c345c&response_type=code&redirect_uri=${process.env.REACT_APP_REDIRECT}&scope=https://graph.microsoft.com/.default`}
                style={{
                  width: '100%',
                  textDecoration: 'none',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // marginTop: '8px', // Add margin for spacing from text
                }}
              >
                <CustomButton
                  disabled={false}
                  onClick={() => {
                    sessionStorage.setItem('meeting-connecting', 'true');
                  }}
                  variant='outlined'
                  color='secondary'
                  style={{
                    width: '95px',
                    borderRadius: '14px',
                    height: '48px',
                    backgroundColor: zeplinColor.Brand1,
                    gap: '16px',
                    padding: '14px 16px',
                  }}
                  textStyle={{ color: zeplinColor.Neutral1 }}
                  text={'Connect'}
                />
              </Link>
            )}
          </Box>
        ) : loading ? (
          <Box
            sx={{
              overflowY: 'scroll',
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              position: 'relative',
              height: { xs: 'calc(100vh - 630px)', xl: 'calc(100vh - 770px)' },
              // height:
              //   screenHeight > 1200
              //     ? '28vh'
              //     : screenHeight > 1100
              //     ? '24vh'
              //     : screenHeight > 1000
              //     ? '20vh'
              //     : screenHeight > 900
              //     ? '17vh'
              //     : screenHeight > 800
              //     ? '10vh'
              //     : '2vh',
            }}
          >
            {[1, 2, 3, 4, 5].map((val: any) => (
              <TodaysMeetingCard
                key={val}
                loading={true}
                data={{
                  attendees: [''],
                  body: '',
                  end: '',
                  location: '',
                  meetingLink: '',
                  organizer: '',
                  start: '',
                  subject: '',
                }}
              />
            ))}
          </Box>
        ) : (
          // </Box>
          <Box
            sx={{
              overflowY: 'scroll',
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              position: 'relative',
              // height:
              //   screenHeight > 1200
              //     ? '28vh'
              //     : screenHeight > 1100
              //     ? '24vh'
              //     : screenHeight > 1000
              //     ? '20vh'
              //     : screenHeight > 900
              //     ? '17vh'
              //     : screenHeight > 800
              //     ? '10vh'
              //     : '2vh',
              height: { xs: 'calc(100vh - 630px)', xl: 'calc(100vh - 770px)' },
            }}
          >
            {Array.isArray(events) &&
              events.map((val) => (
                <TodaysMeetingCard key={val?.meetingLink} data={val} loading={false} />
              ))}
          </Box>
        )}
      </>
    );
    // </Box>
  };
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        // flex: 1,
        // height: '25vh',
        position: 'relative',
        overflowY: 'hidden',
        gap: '20px',
        // paddingTop: '10px',
      }}
    >
      <Header />
      <Column />
      {/* <InfiniteScrollColumn header={<Header />} content={<Column />} height='30vh' /> */}
    </Box>
  );
};

export default TodaysMeeting;
